<template>
  <div id="index">
    <el-card class="index">
      <div class="menu">
        <el-menu
          :default-active="$route.name"
          :key="key"
          class="el-menu-demo"
          mode="horizontal"
          @select="SelectMenu"
        >
          <!-- <el-menu-item index="bankrupt">破产案例</el-menu-item> -->
          <el-menu-item
            v-for="(item, index) in targetRoutes"
            :key="index"
            :index="item.path"
          >
            {{ item.meta.title }}
          </el-menu-item>
        </el-menu>
        <!-- 折腾跳转是出现的文字 -->
        <div class="kb"></div>
      </div>
      <div class="xian"></div>

      <router-view
        @conflict="GetConflict"
        @Aconflict="AdviserConflict"
        @BConflict = "BanruptcykConflict"
      ></router-view>
    </el-card>

    <!-- 冲突案件 -->
    <!-- <el-card
      class="conflict"
      v-if="
        $route.name == 'Casedetail' &&
        $route.query.type.includes('案件') &&
        !$route.query.type.includes('破产')
      "
    > -->
    <el-card
      class="conflict"
      v-if="$route.name == 'Casedetail' && !$route.query.type.includes('破产案件投标')"
    >
      <div class="menu">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
        >
          <el-menu-item index="1">案件冲突</el-menu-item> </el-menu
        ><span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>

      <div class="xian"></div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
      >
        <el-table-column prop="code" label="项目编号"> </el-table-column>
        <el-table-column prop="title" label="项目名称"> </el-table-column>
        <el-table-column prop="litigant" label="当事人">
          <template slot-scope="scope">
            <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
            <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
              {{ scope.row.litigant[0].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[0].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[0].all.length - 1"
                  >,
                </span>
              </span>
            </div>

            <div v-if="scope.row.litigant[1]" class="litigant-container">
              {{ scope.row.litigant[1].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[1].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[1].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[2]" class="litigant-container">
              {{ scope.row.litigant[2].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[2].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[2].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[3]" class="litigant-container">
              {{ scope.row.litigant[3].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[3].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[3].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[4]" class="litigant-container">
              {{ scope.row.litigant[4].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[4].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[4].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[5]" class="litigant-container">
              {{ scope.row.litigant[5].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[5].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[5].all.length - 1"
                  >,
                </span>
              </span>
            </div> -->
          </template>
        </el-table-column>
        <!-- <el-table-column prop="litigant[0].all" label="参与方1">
          <template slot-scope="scope" v-if="scope.row.litigant[0]">
            <span
              v-for="(item, index) in scope.row.litigant[0].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span :style="{ color: getRandomColor(item.isClient) }">{{
                item.name
              }}</span>
              <span v-if="index < scope.row.litigant[0].all.length - 1"
                >,
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="litigant[1].all" label="参与方2">
          <template slot-scope="scope" v-if="scope.row.litigant[1]">
            <span
              v-for="(item, index) in scope.row.litigant[1].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span :style="{ color: getRandomColor(item.isClient) }">{{
                item.name
              }}</span>
              <span v-if="index < scope.row.litigant[1].all.length - 1"
                >,
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="litigant[2].all" label="参与方3">
          <template slot-scope="scope" v-if="scope.row.litigant[2]">
            <span
              v-for="(item, index) in scope.row.litigant[2].all"
              :key="item.id"
              style="display: inline"
            >
              <span v-if="item.isshow" style="color: red; font-weight: 900"
                >!</span
              >
              <span :style="{ color: getRandomColor(item.isClient) }">{{
                item.name
              }}</span>
              <span v-if="index < scope.row.litigant[2].all.length - 1"
                >,
              </span>
            </span>
          </template>
        </el-table-column> -->
        <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
        <el-table-column prop="entrustmentTime" label="上传时间">
          <template slot-scope="scope">
            {{ handleTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.isOther"
              type="success"
              plain
              size="small"
              @click="Look(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div v-if="hasMore" style="text-align: center;">
          <el-button  type="text" @click="showAllCaseClick" >
            {{ showAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>
    </el-card>

    <!-- 顾问冲突 -->
    <!-- <el-card
      class="conflict"
      v-if="
        $route.name == 'Casedetail' &&
        $route.query.type.includes('案件') &&
        !$route.query.type.includes('破产')
      "
    > -->
    <el-card
      class="conflict"
      v-if="$route.name == 'Casedetail' && !$route.query.type.includes('破产')"
    >
      <div class="menu">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
        >
          <el-menu-item index="1">顾问冲突</el-menu-item> </el-menu
        ><span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
      <div class="xian"></div>
      <el-table
        :data="AdviserData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
      >
        <el-table-column prop="unitName" label="顾问单位">
          <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900"
              v-if="scope.row.isClient == 1"
              >!</span
            >
            <span
              :style="{
                color: getRandomColor1(scope.row.isClient)
              }"
            >
              {{ scope.row.unitName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumber" label="身份证号/社会信用代码"> </el-table-column>
        <el-table-column prop="lawyer" label="承办律师"> </el-table-column>

        <el-table-column prop="unitType" label="单位性质"> </el-table-column>
        <el-table-column prop="endTime" label="到期时间">
          <template slot-scope="scope">
            {{ handleTime(scope.row.endTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="success" plain size="small" @click="Look(scope.row)">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </el-card>

     <el-card
      class="conflict"
      v-if="$route.name == 'Casedetail' && !$route.query.type.includes('破产')"
    >
      <div class="menu">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
        >
          <el-menu-item index="1">破产管理人冲突</el-menu-item> </el-menu
        ><span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方,灰色背景是导入数据)</span
        >
      </div>
      <div class="xian"></div>
      <el-table
        :data="BanruptcykConflictData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
      >
         <el-table-column prop="name" label="破产企业名称">
          <template slot-scope="scope">
            <span
              style="color: red; font-weight: 900"
              v-if="scope.row.isClient == 1"
              >!</span
            >
            <span
              :style="{
                color: getRandomColor1(scope.row.isClient)
              }"
            >
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumber" label="身份证号/社会信用代码"> </el-table-column>
        <el-table-column prop="soure" label="破产项目来源"> </el-table-column>
         <el-table-column prop="mainName" label="代理律师(主)"> </el-table-column>
          <el-table-column prop="deputyName" label="代理律师(副)">
             <template slot-scope="scope">
    {{ scope.row.deputyName ? scope.row.deputyName.join('、') : '' }}
  </template>
   </el-table-column>
        
        <el-table-column prop="collectionDate" label="收案日期">
          <template slot-scope="scope">
           {{ handleTime(scope.row.collectionDate) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div style="margin-top: 45px; width: 100%; height: 1px"></div>
  </div>
</template>
  
<script>
// import { mapActions } from "vuex";
// import Table from "../../components/case/List/Table.vue";
export default {
  name: 'Caseapprove',
  // components:{
  //   Table
  // },
  data() {
    return {
      Casedetai: false,
      tableData: [], //案件冲突
      AdviserData: [], //顾问冲突
      person: [],
      activeIndex: '1',

      showAllCase:false,//是否显示全部冲突案件
      hasMore:false,
      allConflictCase:[],//所有的冲突案件

      BanruptcykConflictData:[],
    }
  },

  methods: {
    GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
    showAllCaseClick(){
      if(this.showAllCase){
        this.showAllCase=false
        this.tableData = this.allConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
        if(this.tableData.length==0){//没有冲突案件
          this.tableData.push(this.allConflictCase[0])
        } 
       
      }else{
        this.tableData=this.allConflictCase
        this.showAllCase=true
      }
    },
    getRandomColor1(show) {
      if (show==1) return '#e86e30'
      else return 'blue'
    },
    getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      if(time==''||time==null){
        return ''
      }
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    arrToString(arr) {
      return arr.join(' , ')
    },
    GetConflict(data) {
      this.hasMore=false
      this.showAllCase=false
      if(data.length >0){
            this.allConflictCase =data
            this.tableData =  this.allConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
              if(this.tableData.length==0){//没有冲突案件
                this.tableData.push(this.allConflictCase[0])
              } 
              if(this.allConflictCase.length>this.tableData.length&&this.allConflictCase.length>1){
                this.hasMore=true
              }
          }
      // console.log(data)
    },
    AdviserConflict(data) {
      this.AdviserData = data
    },
    BanruptcykConflict(data){
      this.BanruptcykConflictData = data
    },
    Look(row) {
      var typeId=row.typeId.substring(21, 23)
      if(typeId==12){
        var url =
        '/#/home/case/bankruptdetail?guid=' +
        row.id +
        '&type=' +'破产' 
       
      let mywin = window.open(url, row.title)

      mywin.onload = function () {
          mywin.location.reload()
      }
      }
      else{
        this.$store.commit('setmenustatus', 1)
      var url =
        '/#/home/case/caseinfo?guid=' +
        row.id +
        '&status=' +
        row.typeId +
        '&caseType=' +
        row.typeId.substring(21, 23)
        let mywin = window.open(url, row.title)

        mywin.onload = function () {
            mywin.location.reload()
        }
      }
     
      // this.$store.commit('setmenustatus', 1)
      // this.$router.push({
      //   path: '/home/case/caseinfo',
      //   query: {
      //     guid: item.id,
      //     status: item.typeId,
      //     caseType: item.typeId.substring(21, 23)
      //   }
      // })
    },
    SelectMenu(item) {
      let that = this
      that.$router.push({
        path: `/home/examine/${item}`,
        query: {
          guid: this.$route.query.guid,
          type: this.$route.query.type
        }
      })
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd
      var t = new Date(time)
      var time = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
      return time
    },
    tableRowClass({ row, rowIndex }){
     
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    }
  },
  created() {
    // this.SelectMenu(this.targetRoutes[0].path)
  },
  mounted() {
    // this.activeIndex = this.$route.path;
  },
  filters: {
    getRouterActive(path) {
      let str = path.split('/')
      if (str[3] == 'Sealdetail') {
        str[3] = 'Sealapprove'
      }
      if (str[3] == 'Casedetail') {
        str[3] = 'Caseapprove'
      }
      return str[3]
    }
  },
  computed: {
    key() {
      // console.log(this.$route.name)
      if (this.$route.name == 'Casedetail') {
        return 'Casedetail'
      } else if (this.$route.name == 'Caseapprove') {
        return 'Caseapprove'
      }
    },
    targetRoutes() {
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/examine' //遍历每一个数组，过滤出返回值委true的值
      )
      let arr = []
      if (this.$route.name == 'Casedetail') {
        arr = target[0].children.filter((el) => el.hidden == true)
      } else {
        arr = target[0].children.filter((el) => el.hidden != true)
      }

      return arr
    }
  }
}
</script>
  
<style lang="less" scoped>
#index {
  width: 100%;
}

.index {
  width: 98%;
  margin: auto;
  border-radius: 16px;
  position: relative;
}

.el-menu {
  display: flex;
  text-align: center;
  border-right: 0px;
  // margin-bottom: 5vh;
  // .el-menu-item{
  //   width:20vh;
  // }

  .el-menu-item {
    font-size: 16px;
    height: 55px;

    &:hover {
      background-color: #fff;
      color: #409eff !important;
      border-bottom: 1px solid #409eff;
    }
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    border-bottom: 1px solid #409eff;
    color: #409eff !important;
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.menu {
  width: 96%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/.el-card__body,
.el-main {
  padding: 0px;
  padding-bottom: 20px;
}

.xian {
  width: 100%;
  border-bottom: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 24px;
}

.look {
  color: #0caf60;
  background: #e7f7ef;
}

.kb {
  width: 98px;
  height: 48px;
  position: absolute;
  top: 8px;
  right: 2%;
  background: #fff;
  // background: #cf1212;
  z-index: 1;
}

// 案件冲突
.conflict {
  width: 98%;
  margin: 12px auto;
  border-radius: 16px;
}
.litigant-container {
  // text-align: left;
}
/deep/.beig-row{
      background: #e6e5e4 !important;
  }
</style>
  